import { render, staticRenderFns } from "./MntCategory.vue?vue&type=template&id=0ce42f13"
import script from "./MntCategory.vue?vue&type=script&lang=js"
export * from "./MntCategory.vue?vue&type=script&lang=js"
import style0 from "./MntCategory.vue?vue&type=style&index=0&id=0ce42f13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports